import { render, staticRenderFns } from "./RegistryGroups.vue?vue&type=template&id=2ce40e52&"
import script from "./RegistryGroups.vue?vue&type=script&lang=js&"
export * from "./RegistryGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports